import { Container, Row, Col } from 'components/GridSystem';

import * as S from './styles';

export type HeaderProps = {
  variant?: 'primary' | 'secondary';
};

const Header = ({ variant = 'primary' }: HeaderProps) => {
  return (
    <S.Wrapper variant={variant}>
      <Container>
        <Row>
          <Col xs={12} sm={12} xl={6}>
            <a aria-label="Savings Club Link" href="https://savings.club/">
              <S.Logo variant={variant} />
            </a>
          </Col>
          <S.RightCol xl={6}>
            <S.CopyrightText variant={variant}>
              Copyright © {new Date().getFullYear()} Saving’s Club | All rights reserved.
            </S.CopyrightText>
          </S.RightCol>
        </Row>
      </Container>
    </S.Wrapper>
  );
};

export default Header;
